import { FormEvent } from "react"
import { toast } from "react-toastify"
import { SerializedError } from "@reduxjs/toolkit"
import { FetchBaseQueryError } from "@reduxjs/toolkit/query"

import { usePackWHManagerOrderItemMutation } from "store/api/warehouseManagerApi"
import { ApiTypes } from "types"

import getErrorMessage from "utils/getErrorMessage"
import { ShippingModal } from "modals/ShippingModal"

interface Props {
  orderItem: ApiTypes.Model.WHManagerOrderNewItem
  onCancel: () => void
  onSuccess: () => void
}

export const CWAPackingHandler = ({ orderItem, onCancel, onSuccess }: Props) => {
  const [packWHManagerOrderItem, { isLoading: isPackingCWA }] = usePackWHManagerOrderItemMutation()

  const handleCWAPacking = async (event: FormEvent) => {
    event.preventDefault()

    if (!orderItem) return false

    try {
      await packWHManagerOrderItem({
        id: orderItem.id,
        serialNumbers: [],
      }).unwrap()

      toast.success("Successfully packed")
      onSuccess()
      return true
    } catch (error) {
      const errorMessage = getErrorMessage(error as FetchBaseQueryError | SerializedError | undefined)
      if (errorMessage) {
        toast.error(errorMessage)
      }
      return false
    }
  }

  return (
    <ShippingModal
      onCancel={onCancel}
      onSuccess={onSuccess}
      customOnSubmit={handleCWAPacking}
      isFetching={isPackingCWA}
      orderItemId={orderItem.id}
    />
  )
}
